import api from "./client";

export const notifications = {
  getActive: () => api.get("/notifications/active").then((res) => res.data),
  dismiss: (id: string) => api.post(`/notifications/${id}/dismiss`).then((res) => res.data),
  getAll: (page: number = 1, limit: number = 20, search?: string) => {
    let url = `/notifications?page=${page}&limit=${limit}`;
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return api.get(url).then((res) => res.data);
  },
  create: (data: { title: string; message: string; expiresAt?: string | null; isActive?: boolean }) =>
    api.post("/notifications", data).then((res) => res.data),
  update: (id: string, data: { title?: string; message?: string; expiresAt?: string | null; isActive?: boolean }) =>
    api.patch(`/notifications/${id}`, data).then((res) => res.data),
  delete: (id: string) => api.delete(`/notifications/${id}`).then((res) => res.data),
};
